import { useTranslator } from 'tradera/lang/translate';
import VerificationIcon from 'tradera/blueprint/theme/icons-colored/verification.svg?jsx';
import ForwardIcon from 'tradera/blueprint/theme/icons2/forward.svg?jsx';

import { useAppDispatch, useAppSelector } from 'tradera/state/hooks';
import { selectMemberState } from 'tradera/state/member/selectors';
import { openModal } from 'tradera/state/ui/reducer';
import { headerInternationalIdentificationModalId } from 'tradera/components/international-identification-modal/header-international-identification-modal';

export const InternationalIdentificationAlert = () => {
    const dispatch = useAppDispatch();
    const { t } = useTranslator();
    const isInternationalBuyer = useAppSelector(selectMemberState) === 2006;

    if (!isInternationalBuyer) {
        return null;
    }

    return (
        <div
            className="d-flex py-1 px-2 cursor-pointer border border-primary"
            onClick={() =>
                dispatch(
                    openModal({
                        modalId: headerInternationalIdentificationModalId,
                        data: { purpose: 'Identification' }
                    })
                )
            }>
            <VerificationIcon className="icon icon-xl mr-2 flex-shrink-0" />
            <div className="d-flex flex-column flex-grow-1 text-styled">
                <span className="font-weight-bold">
                    {t('siteheader_verificationAlert_line1')}
                </span>
                <div className="d-flex justify-content-between align-items-center">
                    <span>{t('siteheader_verificationAlert_line2')}</span>
                    <ForwardIcon className="icon icon-xs flex-shrink-0 ml-1" />
                </div>
            </div>
        </div>
    );
};
